// extracted by mini-css-extract-plugin
module.exports = {"mobile":"Dropdown_mobile__X7v4y","desktop":"Dropdown_desktop__zA9F3"};